import { Box, styled, Container as MuiContainer, alpha, Typography } from '@mui/material'
import { preventForwardProp } from 'utils/styledUtils'
import { IBlurredContainer, ICaseStudyContainer } from './types'

export const MainBody = styled(Box)(({ theme }) => ({
  ...theme.typography.subtitle1,
  color: theme.palette.surface[50],
  '& a': {
    color: theme.palette.primary[500],
  },
}))

export const Container = styled(MuiContainer)(({ theme }) => ({
  padding: theme.spacing(3, 3),
  maxWidth: '1440px',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3, 4),
  },
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(3, 12),
  },
  [theme.breakpoints.up('lg')]: {
    padding: theme.spacing(3, 23),
  },
  [theme.breakpoints.up('xl')]: {
    padding: theme.spacing(3, 20),
  },
}))

export const BlurredContainer = styled(
  Box,
  preventForwardProp('isBlocked'),
)<IBlurredContainer>(({ theme, isBlocked }) => ({
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: '100%',
  minHeight: '100%',
  flex: 1,
  background: alpha(theme.palette.surface.A900, 0.6),
  backdropFilter: 'blur(10px)',
  zIndex: 10,
  paddingBottom: theme.spacing(2),
  display: isBlocked ? 'flex' : 'none',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(0, 3),
}))

export const InfoWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  maxWidth: '90%',
  display: 'flex',
  flexDirection: 'column',
  background: 'black',
  borderRadius: '12px',
  filter: `drop-shadow(1px 1px 4px #252A30) drop-shadow(-1px -1px 4px #252A30)`,
  [theme.breakpoints.up('md')]: {
    maxWidth: '50%',
    alignItems: 'center',
  },
}))

export const CaseStudyContainer = styled(
  Box,
  preventForwardProp('isBlocked'),
)<ICaseStudyContainer>(({ isBlocked }) => ({
  maxHeight: isBlocked ? '700px' : 'auto',
  overflow: isBlocked ? 'hidden' : 'auto',
}))

export const GatedContainerTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h6,
  marginBottom: theme.spacing(2),
}))

export const CaseStudyImageWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  wiidth: '100%',
  height: '200px',
  borderRadius: '30px',
  overflow: 'hidden',
  margin: theme.spacing(3, 0),
  [theme.breakpoints.up('sm')]: {
    height: '250px',
  },
  [theme.breakpoints.up('md')]: {
    height: '300px',
  },
  [theme.breakpoints.up('lg')]: {
    height: '350px',
  },
}))
